<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="container" v-if="show" style="margin-top:88px">
      <p>&zwnj;</p>

      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Home">
              <span class="text-primary">
                Home
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item">
            <router-link to="/PressReleases/Page=1">
              <span class="text-primary">
                Press Releases
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item active" aria-current="page">{{ NewsInfo.NewsTopic }}</li>
        </ol>
      </nav>
      <p>&zwnj;</p>

      <div class="row align-items-center">
        <div class="col-lg-4 mb-4">
          <div class="logImgFrame">
            <img :src="`//www.chanchao.com.tw/exhibitorservicefiles/logo/${NewsInfo.ComLogo}`" width="80%" />
          </div>
        </div>
        <div class="col-lg-8 mb-4">
          <h3>{{ NewsInfo.NewsTopic }}</h3>

          <p class="mt-3 mb-1">
            <span class="info_size">
              Exhibitor :
            </span>
            <a
              :href="`https://www.chanchao.com.tw/bioasiataiwan/onlineexpo/ExhibitorDetail/${RegNo}`"
              target="_blank"
              style="text-decoration:none;color:rgb(15 145 197)"
            >
              {{ NewsInfo.ComName }}
            </a>
          </p>
          <p>
            <span class="info_size">
              Date :
            </span>
            {{ NewsInfo.UpdateTime }}
          </p>
          <div class="mt-4">
            <span
              class="badge border shadow-sm iconOpenHover"
              style="padding:12px"
              @click="openInquiryContent"
              data-toggle="tooltip"
              data-placement="bottom"
              title="Inquiry"
            >
              <img src="../../assets/images/chat9.png" width="24px" alt="" />
            </span>
          </div>
        </div>
      </div>

      <p>&zwnj;</p>

      <div v-html="filterContent"></div>

      <p class="mt-3" v-if="NewsInfo.NewsUrl">
        <a :href="NewsInfo.NewsUrl" target="_blank" style="color:#4e79f6">
          <i class="fas fa-external-link-alt mr-2"></i>
          Related Link</a
        >
      </p>

      <p>&zwnj;</p>
      <p>&zwnj;</p>

      <div v-if="otherNewsNum > 0">
        <div class="recommend-title">
          <span class="recommend-content ">
            <span class="title_fontStyle" style="font-size:28px">
              Other Press Release
            </span>
          </span>
        </div>

        <div class="my-5" v-for="item in otherNewsList">
          <div class="pointer my-3" @click.prevent="goNewsDetial(item.NewsNo)">
            <p class="h5 title_fontStyle pb-1">
              {{ item.NewsTopic }}
            </p>
            <p>
              {{ item.ComName }}
            </p>
            <p class="text-muted mt-1">
              <i class="far fa-calendar mr-2"></i>
              {{ item.UpdateTime }}
            </p>
          </div>
        </div>
        <p>&zwnj;</p>
        <p>&zwnj;</p>
      </div>
    </div>

    <!-- 彈跳視窗區 -->

    <!-- 留言區資訊 -->

    <div
      class="modal fade"
      id="openInquiryContent"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
          <div class="modal-header modal-title-bg">
            <h3 class="title_fontStyle ml-2">
              <img src="../../assets/images/title_chat.png" width="35px" class="mr-1" alt="" />
              Inquiry
            </h3>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body mb-2 px-4">
            <div class="mt-2 mb-4" style="font-size:20px">
              {{ NewsInfo.ComName }}
            </div>

            <div class="row">
              <div class="col-lg-6 mb-4">
                <p class="font-weight-bold" style="font-size:18px">Name</p>
                <p>{{ Username }}</p>
              </div>
              <div class="col-lg-6 mb-4">
                <p class="font-weight-bold" style="font-size:18px">Email</p>
                <p>{{ Useremail }}</p>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-6">
                <div class="form-group mb-4">
                  <label for="inputTel" class="form_title ">Tel</label>
                  <input class="form-control" type="text" id="inputTel" maxlength="30" v-model="CompanyTel" />
                </div>
              </div>
              <div class="col-lg-6">
                <div class="form-group mb-4">
                  <label for="inputTel" class="form_title ">Mobile</label>
                  <input class="form-control " type="text" id="inputTel" maxlength="30" v-model="allPhone" />
                </div>
              </div>
            </div>

            <div class="mb-3">
              <label for="validationTextarea" style="font-size:18px" class="font-weight-bold"
                >Content <span style="color:red">*</span></label
              >
              <textarea
                type="text"
                class="form-control"
                rows="6"
                id="validationTextarea"
                placeholder=""
                v-model="InquiryContent"
                name="Content"
                :class="{ 'is-invalid': errors.first('Content') }"
                v-validate="'required'"
              ></textarea>

              <span class="text-danger" style="font-size: 10px" v-if="errors.first('Content')">
                <i class="fas fa-exclamation-triangle"></i> The Content field is required
              </span>
            </div>
            <div class="d-flex justify-content-center">
              <div class="btn btn-primary px-4" @click.prevent="SendInquire">Send</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        NewsInfo: {},
        RegNo: '',
        otherNewsList: [],
        show: false,
        otherNewsNum: '',

        Useremail: '',
        Username: '',
        CompanyTel: '',
        allPhone: '',
        InquiryContent: '',
        filterContent: '',

        hasChatStatue: false,
      }
    },

    watch: {
      $route(to, from) {
        this.getNewsDetial()
      },
    },

    methods: {
      // 打開指定即時通訊聯絡人

      openInquiryContent() {
        $('#openInquiryContent').modal('show')

        const vm = this

        let NowPageUrl = location.href
        let OpenInquireURL = `${NowPageUrl}#inquiry`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenInquireURL,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      },

      goNewsDetial(id) {
        this.$router.push(`/PressReleaseDetail/${id}`)
        // this.getNewsDetial()
      },

      getNewsDetial() {
        const vm = this
        vm.$store.dispatch('updateLoading', true)
        vm.show = false

        vm.$store.dispatch('updateList', false)
        vm.$store.dispatch('Updatevisible', true)

        //取得新聞稿詳細資料
        vm.$http
          .get(
            `https://www.chanchao.com.tw/apiOnlineExpo/v1/PressReleaseDetail/${vm.exhcode}/${vm.$route.params.MyNewsId}?Lang=en`
          )
          .then((response) => {
            vm.NewsInfo = response.data
            vm.RegNo = response.data.RegNo

            let getContent = response.data.NewsContent
            let deletword = getContent.replace(/<br>/g, '')
            vm.filterContent = deletword

            //取得新聞稿其他推薦
            vm.$http
              .get(
                `https://www.chanchao.com.tw/apiOnlineExpo/v1/OtherPressRelease/${vm.exhcode}/${vm.RegNo}/${vm.$route.params.MyNewsId}?Lang=en`
              )
              .then((response) => {
                vm.otherNewsList = response.data
                vm.otherNewsNum = vm.otherNewsList.length
                // vm.show = true
                // vm.$store.dispatch('updateLoading', false)
              })
          })

        // 取得自身資料
        vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/regInformation').then((response) => {
          vm.Useremail = response.data.email
          vm.Username = response.data.cname

          if (response.data.Ext) {
            vm.CompanyTel = response.data.Tel + '#' + response.data.Ext
          } else {
            vm.CompanyTel = response.data.Tel
          }

          // //手機組合

          let mobilenum = response.data.mobile
          let mobArea = response.data.MobileCountryCode
          vm.allPhone = mobArea + mobilenum
        })

        //紀錄瀏覽

        vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
          let CSRFToken = response.data
          vm.CSRF_Token = response.data

          let NowPageUrl = location.href

          const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
          const info = {
            Type: 'NID',
            ID: vm.$route.params.MyNewsId,
            Url: NowPageUrl,
            CSRF: CSRFToken,
          }
          vm.$http.post(url, info).then(function(response) {
            if (response.data == '200') {
              // console.log('Log success')
            } else if (response.data == '251') {
              // console.log('Log fail')
            }
          })
        })
      },

      alertError() {
        const vm = this
        vm.$swal({
          text: vm.alertText,
          icon: 'info',
          confirmButtonText: 'OK',

          allowOutsideClick: true,
          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        })
      },

      alertSuccess() {
        const vm = this

        vm.$swal({
          title: vm.alertTitle,
          text: vm.alertText,
          icon: 'success',
          confirmButtonText: 'OK',

          confirmButtonColor: '#abc6d2',
          width: 300,
          padding: 15,
        }).then(function() {
          $('#openInquiryContent').modal('hide')
        })
      },

      // 傳詢問問題
      SendInquire() {
        const vm = this

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/Inquire/${vm.exhcode}`
        const info = {
          exhcode: vm.exhcode,
          CSRF: vm.CSRF_Token,
          CName: vm.Username,
          Email: vm.Useremail,
          Tel: vm.CompanyTel,
          Mobile: vm.allPhone,
          Inquiry: vm.InquiryContent,
          Type: 'NID',
          ID: vm.$route.params.MyNewsId,
        }

        vm.$validator.validate().then((valid) => {
          if (valid) {
            vm.$store.dispatch('updateLoading', true)

            vm.$http.post(url, info).then(function(response) {
              if (response.data == '200') {
                vm.$store.dispatch('updateLoading', false)

                vm.alertTitle = 'Success'
                vm.alertText = 'Your inquiry has been sent'

                vm.alertSuccess()
              } else if (response.data == '252') {
                window.location.replace(`https://www.chanchao.com.tw/en/`)
              } else if (response.data == '251') {
                vm.$store.dispatch('updateLoading', false)

                vm.alertText = 'Server is busy, please try again later.'

                vm.alertError()
              } else if (response.data == '253') {
                vm.$store.dispatch('updateLoading', false)

                vm.alertText = ' Email error'
                vm.alertError()
              }
            })
          } else {
            vm.alertText = 'Your request could not be completed.'
            vm.alertError()
          }
        })
      },
    },

    computed: {
      ...mapGetters(['ListStatus', 'Roomvisible', 'exhcode']),
    },
    created() {
      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)
      const vm = this

      vm.$store.dispatch('updateLoading', true)
      vm.show = false

      $(function() {
        $('#openInquiryContent').on('hide.bs.modal', function() {
          vm.InquiryContent = ''
        })
      })
      //取得新聞稿詳細資料
      vm.$http
        .get(
          `https://www.chanchao.com.tw/apiOnlineExpo/v1/PressReleaseDetail/${vm.exhcode}/${vm.$route.params.MyNewsId}?Lang=en`
        )
        .then((response) => {
          vm.NewsInfo = response.data
          vm.RegNo = response.data.RegNo

          let getContent = response.data.NewsContent
          let deletword = getContent.replace(/<br>/g, '')
          vm.filterContent = deletword

          //取得新聞稿其他推薦
          vm.$http
            .get(
              `https://www.chanchao.com.tw/apiOnlineExpo/v1/OtherPressRelease/${vm.exhcode}/${vm.RegNo}/${vm.$route.params.MyNewsId}?Lang=en`
            )
            .then((response) => {
              vm.otherNewsList = response.data
              vm.otherNewsNum = vm.otherNewsList.length
              vm.show = true
              vm.$store.dispatch('updateLoading', false)
            })
        })

      // 取得自身資料
      vm.$http.get('https://www.chanchao.com.tw/apiRegister/v1/regInformation').then((response) => {
        vm.Useremail = response.data.email
        vm.Username = response.data.cname

        // vm.CompanyTel = response.data.Tel + '#' + response.data.Ext

        if (response.data.Ext) {
          vm.CompanyTel = response.data.Tel + '#' + response.data.Ext
        } else {
          vm.CompanyTel = response.data.Tel
        }

        // //手機組合

        let mobilenum = response.data.mobile
        let mobArea = response.data.MobileCountryCode
        vm.allPhone = mobArea + mobilenum
      })

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        let CSRFToken = response.data
        vm.CSRF_Token = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: 'NID',
          ID: vm.$route.params.MyNewsId,
          Url: NowPageUrl,
          CSRF: CSRFToken,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            // console.log('Log success')
          } else if (response.data == '251') {
            // console.log('Log fail')
          }
        })
      })
    },
  }
</script>
<style lang="scss" scoped>
  .logImgFrame {
    width: 350px;
    min-height: 300px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .card {
    -webkit-box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
    -moz-box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
    box-shadow: -1px 1px 24px -7px rgba(92, 89, 92, 0.09);
    min-height: 310px;

    @media (max-width: 576px) {
      min-height: 240px;

      .modal-content {
        height: auto;
      }
    }
  }

  .modal-content {
    height: 82vh;
    overflow-y: hidden;
  }

  .modal-body {
    overflow-y: scroll;
  }

  .card-header {
    margin-bottom: 0;
    background-color: #dadddd;
    border-bottom: 0px;
    position: relative;
  }

  .iconOpenHover {
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      transform: scale(1.1);
    }
  }
</style>
